module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAUklEQVRYhe3WwQkAIAxD0Y7WQw/Z2tF0BRGkRP+D3HMpTQQAvEVSOiUkZVVNh/gWdkr3CQEAcJnlluguclJ4OITxAwD4gN1rdh0/7WW2CwPAWxY5N7dPgPyKFAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_button@2x.png
// module id = UO+b
// module chunks = 28